import { render, staticRenderFns } from "./ImageCanvas.global.vue?vue&type=template&id=58e75534&scoped=true&lang=pug&"
import script from "./ImageCanvas.global.vue?vue&type=script&lang=ts&"
export * from "./ImageCanvas.global.vue?vue&type=script&lang=ts&"
import style0 from "./ImageCanvas.global.vue?vue&type=style&index=0&id=58e75534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e75534",
  null
  
)

export default component.exports